import React, { useEffect, useMemo, useState } from 'react';

import { createBrowserRouter, RouterProvider, useNavigate, Link, useLocation } from 'react-router-dom';
import { Notification, PDFViewer, DragNDrop, EmptyElement, BackButton, PageNotFound, Spacer, Spacer25, Spacer100, Spacer10, ChooseAvailableFile, AvailableDocSelect, LoadingDocs } from './Utils';
import strs from './strings';
import caseTerms from './case'; 
import curCase from './testCase';
import docsAll from './docs';
import { FullscreenDocument } from './Popups';
import Select from 'react-select';
import { useMediaQuery } from '@mui/material';
import { getCase, setCase } from './firestore';
import { formatDate, formatISODate, genExistingDocURLs } from './utilFunctions';
import { NonLucrativeResidencyRenewal, SpanishCitizenship, StudentStay, StudentStayRenewal, UnsubmittedCase } from './procedures/immigration_and_citizenship';
import { nanoid } from 'nanoid';
import { uploadFile } from './googleCloudStorage';
import { FormContext } from './context';
import { ArraigoSocial } from './procedures/arraigo_social';
import { ArraigoSociolaboral } from './procedures/arraigo_sociolaboral';
import { ArraigoSegundaOportunidad } from './procedures/arraigo_segunda_oportunidad';
import { ArraigoSocioformativo } from './procedures/arraigo_socioformativo';
import { ArraigoFamiliar } from './procedures/arraigo_familiar';

const lang = strs.en;
const docs = docsAll.en;

const colorStyles = {
	control: (styles) => ({
		...styles,
// 		color: 'black',
		backgroundColor: '#e8eef6',
		border: '1px solid gray',
// 		minWidth: '636px',
		minHeight: '48px',
// 		margin: '1rem'
	}),
}


export default function Case() {
	const location = useLocation();
	const { openCase } = location.state || {};

	const path = window.location.pathname;
	const caseUUID = path.substring(path.lastIndexOf('/') + 1);

// 	const [curCase, setCurCase] = useState(openCase);
	const [curCase, setCurCase] = useState(null);
	const globalForm = curCase;
	const setGlobalForm = setCurCase;

	const [caseDocURLs, setCaseDocURLs] = React.useState(undefined);
	const [caseResponses, setCaseResponses] = React.useState([]);
	const [caseResponsesLen, setCaseResponsesLen] = React.useState(0)
	const [caseNotifications, setCaseNotifications] = React.useState([]);
	const [notification, setNotification] = React.useState(false);
	const [formData, setFormData] = React.useState({
		docType: null,
		doc: null,
		textArea: '',
	})

// 	const unsubmittedCase = findReactElement(curCase.caseType)
	let unsubmittedCase = null;

	const [iframeDoc, setIframeDoc] = React.useState('');
	const [isIframe, setIsIframe] = React.useState('hidden');
	let isMobilePortraitScreen = !useMediaQuery('screen and (min-width: 756px)');


// 	const value = useMemo(
// 		() => ({curCase, setCurCase, caseDocURLs, setCaseDocURLs, formData, setFormData}),
// 		[curCase, setCurCase]
// 	)


	
	function addToReceivedNotifications(receivedNotification) {
		console.log('receivedNotification', receivedNotification);
// 		setCaseNotifications((prevCaseNotifications) => {
// 			return [
// 				receivedNotification,
// 				...prevCaseNotifications,
// 			]
// 		})
	}

	function fileUploaded(file) {
		setFormData({
			docType: formData.docType,
			doc: file,
			textArea: formData.textArea,
		})
	}

	async function uploadCaseDoc() {
		const tmpCase = {...curCase};
		if (!curCase || !curCase.docs || curCase.docs.length === 0) return;
		const updatedDocs = [...tmpCase.docs]; // Copy the docs array
		const lastDocIndex = updatedDocs.length - 1; // Index of the last element
		updatedDocs[lastDocIndex] = {
			...updatedDocs[lastDocIndex], // Copy the last document
			message: formData.textArea, // Update the message
		};
		tmpCase.docs = updatedDocs;
		console.log('about to update case', tmpCase);
		setCase(tmpCase.id, tmpCase);
		setCurCase(tmpCase)

		setFormData( () => ( {
			docType: null,
			doc: null,
			textArea: '',
		}));
		
	}

	function handleSelectChange (selectedOption) {
		setFormData({
			...formData,
			docType: selectedOption.value,
		})
	}

	function handleTextAreaChange(event) {
		setFormData({
			...formData,
			textArea: event.target.value,
		})		
	}


	function handleClick(url) {
		console.log('handleClick')
// 		if (isIframe !== 'url')
			setIframeDoc(url);
			console.log('handleClick setIframeDoc', url);
		setIsIframe('pdf-viewer-fullscreen fade-in')
	}

	function findReactElement(caseType) {
		const caseTypes = {
			studentStay: StudentStay,
			studentStayRenewal: StudentStayRenewal,
			arraigoSocial: ArraigoSocial,
			arraigoSociolaboral: ArraigoSociolaboral,
			arraigoSegundaOportunidad: ArraigoSegundaOportunidad,
			arraigoSocioformativo: ArraigoSocioformativo,
			arraigoFamiliar: ArraigoFamiliar,
			nonLucrativeResidencyRenewal: NonLucrativeResidencyRenewal,
			spanishCitizenship: SpanishCitizenship,
// 			highSchool,
// 			bachelors,
// 			masters,
		}
		
		return caseTypes[caseType];
// 		const unsubmittedCase = caseTypes[caseType];uploadTime: Date.now() / 1000
// 		unsubmittedCase();
	
	}


	useEffect(
		() => {
			const asyncWrapper = async () => {
				if (openCase === "created") return;
				
				const fetchedCase = await getCase(caseUUID);
				setCurCase(fetchedCase);
				if (fetchedCase?.pendingNotifications?.length) {
					setNotification(true);
				}	

			//All of this shit we use fetchedCase as it will be exactly the same as setCurCase (see line of code just above this comment)
				const tmpDocURLs = await genExistingDocURLs(fetchedCase, setCurCase);
				setCaseDocURLs(tmpDocURLs);
				console.log('caseDocURLs', tmpDocURLs);
				setCaseResponses(fetchedCase.responseDocs);
				setCaseResponsesLen(fetchedCase.responseDocs.length);
				setCaseNotifications(fetchedCase.notifications);
				unsubmittedCase = findReactElement(fetchedCase.caseType)

			}

			asyncWrapper();
		}
		, []);


	
	if (!curCase || !caseDocURLs) {
		return(
			<LoadingDocs />
		)
	}
	else if (curCase.curStatus === "created") {
		console.log("Unsubmitted case")
		return (
			<UnsubmittedCase resumeCase={true} caseType={curCase.caseType} curCase={curCase}/>
		);

	}
	else {
		console.log('again, caseDocURLs', caseDocURLs);
		return (
		<FormContext.Provider value={{curCase, setCurCase, caseDocURLs, setCaseDocURLs, formData, setFormData, globalForm, setGlobalForm}}>
		<div>
			<BackButton />
			<Spacer />
			<h1 className='primary-title'>{lang.thisCase} - {lang[curCase.caseType]} ({formatDate(curCase.dateOpened)})</h1>
			<Spacer />

			<h1 className='secondary-title centered-text'>{caseTerms.caseOverview}</h1>
			<Spacer />
			<div className='case-status-block'>
				<label for='status' className='p'>{caseTerms.caseStatus} :</label>
				<p className='p basic-flex-nowrap'><strong>{curCase.curStatus.toUpperCase()}</strong></p>

				<label for='status' className='p'>{caseTerms.dateOpened} :</label>
				<p className='p basic-flex-nowrap'>{formatDate(curCase.dateOpened)}</p>
			
				<label for='status' className='p'>{caseTerms.dateSubmitted} :</label>
				<p className='p basic-flex-nowrap'>{formatDate(curCase.dateSubmitted)}</p>

				<label for='status' className='p'>{caseTerms.dateReceived} :</label>
				<p className='p basic-flex-nowrap'>{curCase.dateReceived}</p>
			</div>
			
			<Spacer100 />

			
			<h1 className='secondary-title centered-text' id="notifications">{caseTerms.unreceivedNotifications}</h1>
			<Spacer />


			{
				notification ?
					<center>
						<Notification addToReceivedNotifications={addToReceivedNotifications} />
					</center> 
				: 
				<p className='p centered-text'>{caseTerms.noNotifications}</p>
			}
			



			{
				caseNotifications.length > 0 && 
				<div>
					<Spacer100 />
					<h1 className='secondary-title centered-text' id="notifications">{caseTerms.receivedNotifications}</h1>
				<Spacer />
			</div>
			}
			<div className='fade-in upload-grid'>
			{
				caseNotifications.map((notification) => {
					return (
					<div className='grid-column' key={nanoid()}>
						<p className='p centered-text'>Notification</p>
						<Spacer25 />
						<div className='grow-and-shrink-slightly'>
							<PDFViewer customStyle={'pdf-viewer-small'} noX={true} file={`/case-files/notification1.pdf`} clickCallback={() => handleClick(`/case-files/notification1.pdf`)}  />
							<Spacer25 />
							<p className='centered-text p'><b>{lang.receivedOn}</b>: {formatISODate(notification.timeReceived)}</p>
						</div>
						<Spacer100 />
					</div>
					);

				})

			}	
			</div>
			

			<Spacer100 />

			<h1 className='secondary-title centered-text'>{caseTerms.editCase}</h1>
			<Spacer />
			
			<Select
				options={docsAll.en_list}
				onChange={handleSelectChange}
				classNamePrefix='form-text-item'
				className='large-select'
				styles={colorStyles}
			>
			</Select>


			{
				formData.docType &&
				<>
				<div className='upload-grid'>
					<p className='p centered-text'>{caseTerms.uploadNewDoc}</p>
					<p className='p centered-text'>{caseTerms.addAvailableDoc}</p>
					<DragNDrop text="" large={false} noGrow={false} uploadCallback={fileUploaded} doc={formData.docType}/>
					<ChooseAvailableFile uploadCallback={fileUploaded}/>
				</div>
				<Spacer />

				<div className='fade-in grid-column'>
				<textarea className='text-area' placeholder={lang.optionalMessage} value={formData.textArea} onChange={handleTextAreaChange}></textarea>
				<Spacer25 />
				<button className='form-action-btn' onClick={uploadCaseDoc}>{caseTerms.submitNewDoc}</button>
				</div>
				</>
			}


			<Spacer100 />

			<h1 className='secondary-title centered-text'>Response Docs</h1>
			<Spacer100 />
			<div className={`${caseResponsesLen > 1 ?  'upload-grid' : ''} fade-in`}>
			{
				caseResponses.map( (responseDoc) => {
					return (
					<div className='grid-column' key={nanoid()}>
						<p className='p centered-text'>Response</p>
						<Spacer25 />
						<div className='grow-and-shrink-slightly'>
							<PDFViewer large={false} noX={true} file={responseDoc.url} clickCallback={() => handleClick(responseDoc.url)} customStyle={'pdf-viewer-small'} />
						</div>
						<Spacer100 />

					</div>
					);
				} )
			}
			</div>

			<h1 className='secondary-title centered-text'>{caseTerms.caseDocs}</h1>
			<Spacer100 />
			<div className='fade-in flex-center upload-grid'>
			{
				curCase.docs.map((doc, index) => {
					const uuid = doc.uuid;
// 					console.log('caseDocURLs', caseDocURLs)
// 					console.log('doc', doc);
// 					console.log('index', index);
					console.log('doc', doc)
					return (
					<div className='grid-column' key={nanoid()}>
						<p className='p centered-text'>{docs[doc.docType]}</p>
						<Spacer25 />
						<div className='grow-and-shrink-slightly'>
							<PDFViewer large={false} noX={true} file={caseDocURLs[index].url} clickCallback={() => handleClick(caseDocURLs[index].url)} customStyle={'pdf-viewer-small'} />
						{
							doc.message &&
							<div>
								<Spacer25 />
								<p className='p centered-text'>{lang.message}: {doc.message}</p>
							</div>
						}
						</div>
						<Spacer100 />
					</div>
					);

				})

			}	
			</div>
			<FullscreenDocument visible={isIframe} closeFunc={setIsIframe} src={iframeDoc} />
		</div>
		</FormContext.Provider>
		);
	}
}
